export const SEND_OTP_REQUEST="SEND_OTP_REQUEST"
export const SEND_OTP_SUCCESS="SEND_OTP_SUCCESS"
export const SEND_OTP_FAILURE="SEND_OTP_FAILURE"
